<template>
     <v-card  elevation="15" max-width="250" flat class="mr-5 mb-5 d-inline-block mx-auto" outlined>
                            
                                <v-card-text>
                                <!-- <div>Word of the Day</div> -->
                            
                                <p class="display-1 text--primary  text-truncate">
                                    {{item.product}}
                                </p>
                                <p>{{item.seller}}</p>
                                <div class="text--primary">
                                Bought on: {{item.buyDate}}
                                </div>
                                <div class="text--primary">
                                Warranty: {{item.warrantyMonths}} months
                                </div>
                                
                                </v-card-text>
                                <v-card-actions>
                                <v-btn text small color="primary"
                                        @click="showForm">
                                    Details
                                </v-btn>
                                </v-card-actions>
                            


                        </v-card>
</template>

<script>
export default {
    name:"Warranty",
    props:{item:{
        type:Object,
        required: true
    }}
}
</script>